module.exports = __webpack_public_path__ + "img/10.6ca3d0d.png";